import { useHistory } from 'react-router-dom';

export default function Chip({ onClick, href, newTab = false, className = "", children }) {
    const history = useHistory();
    const Element = href ? "a" : "div";

    function onChipClick(e) {
        onClick?.(e);

        if (href && !href.includes("://")) {
            history.push(href);
        }
    }

    return (
        <Element href={href} {...(newTab ? { target: "_blank", rel: "noopener noreferrer" } : {})} onClick={onChipClick} className={`chip ${(onClick || href) ? "clickable" : ""} ${className}`}>
            {children}
        </Element>
    );
}